// Lightweight i18n dictionary (FR / EN). Use t('key') from useI18n().
export const dict = {
  fr: {
    // Brand / shared
    "brand.name": "Versant Studio",
    "common.lang.fr": "Français",
    "common.lang.en": "English",
    "common.signin": "Connexion",
    "common.signup": "Créer un compte",
    "common.dashboard": "Mon espace",
    "common.logout": "Déconnexion",
    "common.back_home": "Retour au site",
    "common.loading": "Chargement…",
    "common.cancel": "Annuler",
    "common.save": "Enregistrer",
    "common.send": "Envoyer",
    "common.continue_with_google": "Continuer avec Google",
    "common.or": "ou",
    "common.required_field": "Champ requis",

    // Navbar
    "nav.home": "Accueil",
    "nav.services": "Services",
    "nav.work": "Réalisations",
    "nav.simulator": "Simulateur",
    "nav.contact": "Contact",

    // Hero
    "hero.label": "Studio · Web · 2026",
    "hero.title_a": "Des sites web ",
    "hero.title_em": "pensés",
    "hero.title_b": ", construits, et hébergés.",
    "hero.subtitle":
      "Nous concevons des sites vitrines, des boutiques en ligne et des applications web sur mesure. Hébergement, nom de domaine et maintenance — tout est inclus, sans surprise.",
    "hero.cta.simulate": "Lancer une simulation",
    "hero.cta.work": "Voir les réalisations",
    "hero.pillar1_t": "Sur mesure",
    "hero.pillar1_d": "Pas de template — chaque ligne de code est pensée pour vous.",
    "hero.pillar2_t": "Hébergé",
    "hero.pillar2_d": "Infrastructure managée, SSL, backups quotidiens inclus.",
    "hero.pillar3_t": "Transparent",
    "hero.pillar3_d": "Devis détaillé, suivi en direct depuis votre espace client.",
    "hero.pillar4_t": "Indépendant",
    "hero.pillar4_d": "Vous parlez directement à la personne qui développe.",

    // Services
    "services.label": "· 01 — Services",
    "services.title_a": "Quatre disciplines, ",
    "services.title_em": "une seule équipe",
    "services.title_b": ".",
    "services.intro":
      "De la première ligne de code à la mise en ligne, nous prenons en charge l'intégralité du projet. Vous restez concentré sur votre métier.",
    "services.vitrine_t": "Site Vitrine",
    "services.vitrine_d":
      "Présentez votre activité avec élégance. Pages sur mesure, performances optimales, SEO intégré.",
    "services.ecommerce_t": "E-commerce",
    "services.ecommerce_d":
      "Vendez vos produits en ligne. Paiement sécurisé, gestion des stocks, tableau de bord intégré.",
    "services.app_t": "Application Web",
    "services.app_d":
      "Outils internes, plateformes SaaS, espaces clients — pensés pour votre métier.",
    "services.host_t": "Hébergement",
    "services.host_d":
      "Infrastructure managée, backups quotidiens, certificats SSL gratuits.",

    // Portfolio
    "work.label": "· 02 — Réalisations",
    "work.title_a": "Trois exemples ",
    "work.title_em": "interactifs",
    "work.title_b": ".",
    "work.intro":
      "Cliquez sur une réalisation pour voir le rendu en conditions réelles. Ce sont des démos que nous avons construites — elles fonctionnent.",
    "work.cta_open": "Voir la démo",
    "work.example_vitrine_t": "Maison Lautrec",
    "work.example_vitrine_c": "Vitrine · Architecture intérieure",
    "work.example_ecom_t": "Atelier Bruyère",
    "work.example_ecom_c": "E-commerce · Mode artisanale",
    "work.example_app_t": "Plateforme Pléiade",
    "work.example_app_c": "Application · SaaS productivité",

    // Pricing
    "pricing.label": "· 03 — Tarifs & hébergement",
    "pricing.title_a": "Forfaits simples, ",
    "pricing.title_em": "tout inclus",
    "pricing.title_b": ".",
    "pricing.intro":
      "Hébergement, nom de domaine, certificat SSL et maintenance : tout est compris la première année.",
    "pricing.from": "à partir de",
    "pricing.cta": "Configurer mon devis",
    "pricing.foot": "Tarifs HT. Maintenance mensuelle disponible sur demande à partir de 29€/mois.",
    "pricing.t1_t": "Vitrine",
    "pricing.t1_d": "Idéal pour présenter votre activité.",
    "pricing.t1_f1": "Jusqu'à 5 pages",
    "pricing.t1_f2": "Design sur mesure",
    "pricing.t1_f3": "Formulaire de contact",
    "pricing.t1_f4": "SEO de base",
    "pricing.t1_f5": "Hébergement standard inclus",
    "pricing.t2_t": "E-commerce",
    "pricing.t2_d": "Vendez vos produits en ligne.",
    "pricing.t2_f1": "Catalogue produits",
    "pricing.t2_f2": "Paiement Stripe",
    "pricing.t2_f3": "Gestion des commandes",
    "pricing.t2_f4": "Tableau de bord",
    "pricing.t2_f5": "Hébergement premium inclus",
    "pricing.t3_t": "Application",
    "pricing.t3_d": "Plateforme web sur mesure.",
    "pricing.t3_f1": "Authentification utilisateurs",
    "pricing.t3_f2": "API & base de données",
    "pricing.t3_f3": "Tableau de bord avancé",
    "pricing.t3_f4": "Intégrations tierces",
    "pricing.t3_f5": "Hébergement dédié inclus",

    // Simulator
    "sim.label": "· 04 — Simulateur",
    "sim.title_a": "Estimez votre projet ",
    "sim.title_em": "en deux minutes",
    "sim.title_b": ".",
    "sim.intro":
      "Une estimation indicative basée sur votre périmètre. Les tarifs définitifs sont confirmés après échange.",
    "sim.step1": "01 · Type de projet",
    "sim.step2": "02 · Nombre de pages",
    "sim.step3": "03 · Fonctionnalités",
    "sim.step4": "04 · Hébergement (1ère année)",
    "sim.step5": "05 · Nom de domaine",
    "sim.pages_unit": "pages",
    "sim.pages_unit_one": "page",
    "sim.pages_note": "Au-delà de 5 pages : +80€ par page supplémentaire.",
    "sim.domain_label": "Inclure un nom de domaine .fr / .com",
    "sim.summary": "Récapitulatif",
    "sim.summary_total": "Total estimé HT",
    "sim.summary_note": "Acompte 30% au démarrage. Tarif définitif après cadrage.",
    "sim.save_btn": "Enregistrer ce devis",
    "sim.saving": "Enregistrement…",
    "sim.signup_cta": "Créer mon compte pour sauvegarder",
    "sim.contact_cta": "Discuter du projet",
    "sim.type_vitrine": "Site vitrine",
    "sim.type_vitrine_d": "Présentation d'activité",
    "sim.type_ecom": "E-commerce",
    "sim.type_ecom_d": "Boutique en ligne",
    "sim.type_app": "Application web",
    "sim.type_app_d": "Plateforme sur mesure",
    "sim.feat_auth": "Authentification",
    "sim.feat_paiement": "Paiement en ligne",
    "sim.feat_blog": "Blog / actualités",
    "sim.feat_multi": "Multilingue",
    "sim.feat_seo": "SEO avancé",
    "sim.feat_dash": "Tableau de bord client",
    "sim.feat_api": "API / intégrations",
    "sim.host_none": "Sans",
    "sim.host_std": "Standard",
    "sim.host_prem": "Premium",
    "sim.host_yearly": "/an",
    "sim.row_base": "Base —",
    "sim.row_extra": "Pages supplémentaires",
    "sim.row_features": "Fonctionnalités",
    "sim.row_host": "Hébergement (an)",
    "sim.row_domain": "Domaine (an)",

    // Contact
    "contact.label": "· 05 — Contact",
    "contact.title_a": "Parlons de votre ",
    "contact.title_em": "projet",
    "contact.title_b": ".",
    "contact.intro":
      "Décrivez-nous votre besoin en quelques lignes. Nous revenons vers vous sous 24 heures avec un premier diagnostic.",
    "contact.f_name": "Nom *",
    "contact.f_email": "Email *",
    "contact.f_phone": "Téléphone",
    "contact.f_message": "Votre projet *",
    "contact.cta": "Envoyer le message",
    "contact.sending": "Envoi…",
    "contact.success": "Message envoyé. Nous revenons vers vous sous 24h.",
    "contact.error": "Erreur lors de l'envoi. Réessayez.",
    "contact.location": "France · Remote",
    "contact.box_t": "Espace client",
    "contact.box_d":
      "Créez un compte pour suivre votre projet, échanger en direct et consulter vos devis dans un seul endroit.",

    // Footer
    "footer.tagline":
      "Studio indépendant de développement web. Sites vitrines, e-commerce et applications sur mesure. Hébergement et maintenance inclus.",
    "footer.nav": "Navigation",
    "footer.contact": "Contact",
    "footer.rights": "Tous droits réservés.",
    "footer.france": "Conçu et hébergé en France.",

    // Auth
    "auth.login.label": "Connexion",
    "auth.login.title": "Bon retour parmi nous.",
    "auth.login.cta": "Se connecter",
    "auth.login.busy": "Connexion…",
    "auth.login.no_account": "Pas encore de compte ?",
    "auth.login.create": "Créer un compte",
    "auth.email": "Email",
    "auth.password": "Mot de passe",
    "auth.register.label": "Inscription",
    "auth.register.title": "Créez votre compte client.",
    "auth.register.name": "Nom complet",
    "auth.register.password": "Mot de passe (6 caractères min)",
    "auth.register.cta": "Créer mon compte",
    "auth.register.busy": "Création…",
    "auth.register.have_account": "Déjà un compte ?",
    "auth.register.signin": "Se connecter",
    "auth.short_password": "Mot de passe : 6 caractères minimum.",
    "auth.success": "Connecté.",
    "auth.welcome": "Bienvenue.",

    // Verify email
    "verify.title": "Vérifiez votre email",
    "verify.intro":
      "Nous venons de vous envoyer un lien de vérification. Cliquez dessus pour activer votre compte.",
    "verify.resend": "Renvoyer l'email",
    "verify.resent": "Email renvoyé.",
    "verify.success": "Email vérifié. Bienvenue.",
    "verify.failed": "Lien invalide ou expiré.",
    "verify.continue": "Accéder à mon espace",
    "verify.banner_unverified":
      "Votre email n'est pas encore vérifié. Cliquez ici pour renvoyer le lien.",

    // Dashboard
    "dash.section": "· Espace client",
    "dash.tab_overview": "Vue d'ensemble",
    "dash.tab_projects": "Projets",
    "dash.tab_quotes": "Devis",
    "dash.tab_chat": "Messagerie",
    "dash.connected_as": "Connecté en tant que",
    "dash.greeting": "Bonjour",
    "dash.greeting_intro":
      "Voici un aperçu de votre activité. Lancez une nouvelle simulation, consultez vos devis ou envoyez-nous un message.",
    "dash.cta_quote": "Nouveau devis",
    "dash.cta_chat": "Démarrer une discussion",
    "dash.card_projects": "Projets en cours",
    "dash.card_quotes": "Devis enregistrés",
    "dash.card_messages": "Messages",
    "dash.recent_quotes": "Derniers devis",

    // Projects
    "projects.intro": "Suivez l'avancement de vos projets en cours.",
    "projects.new": "Nouveau projet",
    "projects.title": "Titre",
    "projects.description": "Description",
    "projects.create": "Créer",
    "projects.creating": "Création…",
    "projects.empty_t": "Aucun projet pour le moment.",
    "projects.empty_d": "Cliquez sur « Nouveau projet » pour démarrer.",
    "projects.created": "Projet créé.",
    "projects.create_failed": "Création impossible.",
    "projects.status_nouveau": "Nouveau",
    "projects.status_en_cours": "En cours",
    "projects.status_livre": "Livré",
    "projects.status_annule": "Annulé",

    // Quotes
    "quotes.intro": "Vos simulations de devis enregistrées.",
    "quotes.new": "Nouveau devis",
    "quotes.empty_t": "Aucun devis pour le moment.",
    "quotes.empty_d": "Lancez une simulation pour générer votre premier devis.",

    // Chat
    "chat.title": "Conversation",
    "chat.online": "En ligne",
    "chat.offline": "Réponse sous 24h",
    "chat.typical": "Réponses sous 2 à 24 heures",
    "chat.empty": "Démarrez la conversation. Décrivez votre besoin.",
    "chat.placeholder": "Votre message…",
    "chat.send": "Envoyer",
    "chat.aside_note":
      "Notre équipe consulte les messages plusieurs fois par jour. Pour toute urgence, mentionnez « URGENT » dans votre message.",

    // Demos
    "demos.back": "Retour au site",
    "demos.preview_label": "Démo",
    "demos.note":
      "Cet exemple est un aperçu interactif construit par Versant Studio. Vous pouvez en commander un similaire et l'adapter à votre identité.",
    "demos.cta_quote": "Estimer un projet similaire",

    // Admin
    "admin.title": "Espace créateur",
    "admin.online_users": "Visiteurs en ligne",
    "admin.no_online": "Aucun visiteur connecté actuellement.",
    "admin.conversations": "Conversations",
    "admin.no_conv": "Aucune conversation pour le moment.",
    "admin.contacts": "Demandes de contact",
    "admin.no_contacts": "Aucune demande de contact.",
    "admin.users": "Utilisateurs",
    "admin.tab_overview": "Vue d'ensemble",
    "admin.tab_inbox": "Messagerie",
    "admin.tab_users": "Utilisateurs",
    "admin.tab_contacts": "Contacts",
    "admin.reply_placeholder": "Tapez votre réponse…",
    "admin.reply_send": "Envoyer la réponse",
    "admin.stat_users": "Clients",
    "admin.stat_quotes": "Devis",
    "admin.stat_projects": "Projets",
    "admin.stat_contacts": "Contacts",
    "admin.stat_unread": "Messages non lus",
    "admin.select_conv": "Sélectionnez une conversation pour voir les messages.",
  },
  en: {
    "brand.name": "Versant Studio",
    "common.lang.fr": "Français",
    "common.lang.en": "English",
    "common.signin": "Sign in",
    "common.signup": "Sign up",
    "common.dashboard": "Dashboard",
    "common.logout": "Sign out",
    "common.back_home": "Back to site",
    "common.loading": "Loading…",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.send": "Send",
    "common.continue_with_google": "Continue with Google",
    "common.or": "or",
    "common.required_field": "Required",

    "nav.home": "Home",
    "nav.services": "Services",
    "nav.work": "Work",
    "nav.simulator": "Simulator",
    "nav.contact": "Contact",

    "hero.label": "Studio · Web · 2026",
    "hero.title_a": "Web sites that are ",
    "hero.title_em": "thought through",
    "hero.title_b": ", built, and hosted.",
    "hero.subtitle":
      "We design marketing sites, online stores and tailor-made web apps. Hosting, domain name and maintenance — everything is included, no surprises.",
    "hero.cta.simulate": "Run a simulation",
    "hero.cta.work": "See our work",
    "hero.pillar1_t": "Custom",
    "hero.pillar1_d": "No templates — every line of code is built for you.",
    "hero.pillar2_t": "Hosted",
    "hero.pillar2_d": "Managed infrastructure, SSL and daily backups included.",
    "hero.pillar3_t": "Transparent",
    "hero.pillar3_d": "Detailed quote, live tracking from your client area.",
    "hero.pillar4_t": "Independent",
    "hero.pillar4_d": "You talk directly to the person writing the code.",

    "services.label": "· 01 — Services",
    "services.title_a": "Four disciplines, ",
    "services.title_em": "one team",
    "services.title_b": ".",
    "services.intro":
      "From the first line of code to going live, we take care of the whole project. You stay focused on your business.",
    "services.vitrine_t": "Marketing site",
    "services.vitrine_d":
      "Showcase your activity elegantly. Custom pages, optimal performance, built-in SEO.",
    "services.ecommerce_t": "E-commerce",
    "services.ecommerce_d":
      "Sell your products online. Secure payments, inventory, integrated dashboard.",
    "services.app_t": "Web application",
    "services.app_d":
      "Internal tools, SaaS platforms, client portals — designed for your business.",
    "services.host_t": "Hosting",
    "services.host_d":
      "Managed infrastructure, daily backups, free SSL certificates.",

    "work.label": "· 02 — Work",
    "work.title_a": "Three ",
    "work.title_em": "interactive",
    "work.title_b": " examples.",
    "work.intro":
      "Click a project to see the actual interface. These are real demos we have built — they work.",
    "work.cta_open": "Open demo",
    "work.example_vitrine_t": "Maison Lautrec",
    "work.example_vitrine_c": "Marketing · Interior architecture",
    "work.example_ecom_t": "Atelier Bruyère",
    "work.example_ecom_c": "E-commerce · Artisan fashion",
    "work.example_app_t": "Plateforme Pléiade",
    "work.example_app_c": "App · Productivity SaaS",

    "pricing.label": "· 03 — Pricing & hosting",
    "pricing.title_a": "Simple plans, ",
    "pricing.title_em": "all included",
    "pricing.title_b": ".",
    "pricing.intro":
      "Hosting, domain name, SSL certificate and maintenance: everything is covered for the first year.",
    "pricing.from": "from",
    "pricing.cta": "Configure my quote",
    "pricing.foot": "Excl. VAT. Monthly maintenance from €29/month on request.",
    "pricing.t1_t": "Marketing",
    "pricing.t1_d": "Perfect to showcase your activity.",
    "pricing.t1_f1": "Up to 5 pages",
    "pricing.t1_f2": "Custom design",
    "pricing.t1_f3": "Contact form",
    "pricing.t1_f4": "Basic SEO",
    "pricing.t1_f5": "Standard hosting included",
    "pricing.t2_t": "E-commerce",
    "pricing.t2_d": "Sell your products online.",
    "pricing.t2_f1": "Product catalog",
    "pricing.t2_f2": "Stripe payments",
    "pricing.t2_f3": "Order management",
    "pricing.t2_f4": "Dashboard",
    "pricing.t2_f5": "Premium hosting included",
    "pricing.t3_t": "Application",
    "pricing.t3_d": "Custom web platform.",
    "pricing.t3_f1": "User authentication",
    "pricing.t3_f2": "API & database",
    "pricing.t3_f3": "Advanced dashboard",
    "pricing.t3_f4": "Third-party integrations",
    "pricing.t3_f5": "Dedicated hosting included",

    "sim.label": "· 04 — Simulator",
    "sim.title_a": "Estimate your project ",
    "sim.title_em": "in two minutes",
    "sim.title_b": ".",
    "sim.intro":
      "An indicative estimate based on your scope. Final pricing is confirmed after a discovery call.",
    "sim.step1": "01 · Project type",
    "sim.step2": "02 · Number of pages",
    "sim.step3": "03 · Features",
    "sim.step4": "04 · Hosting (1st year)",
    "sim.step5": "05 · Domain name",
    "sim.pages_unit": "pages",
    "sim.pages_unit_one": "page",
    "sim.pages_note": "Above 5 pages: +€80 per extra page.",
    "sim.domain_label": "Include a .fr / .com domain name",
    "sim.summary": "Summary",
    "sim.summary_total": "Estimated total (excl. VAT)",
    "sim.summary_note": "30% deposit at kickoff. Final pricing after scoping.",
    "sim.save_btn": "Save this quote",
    "sim.saving": "Saving…",
    "sim.signup_cta": "Sign up to save",
    "sim.contact_cta": "Discuss the project",
    "sim.type_vitrine": "Marketing site",
    "sim.type_vitrine_d": "Activity showcase",
    "sim.type_ecom": "E-commerce",
    "sim.type_ecom_d": "Online store",
    "sim.type_app": "Web app",
    "sim.type_app_d": "Custom platform",
    "sim.feat_auth": "Authentication",
    "sim.feat_paiement": "Online payment",
    "sim.feat_blog": "Blog / news",
    "sim.feat_multi": "Multilingual",
    "sim.feat_seo": "Advanced SEO",
    "sim.feat_dash": "Client dashboard",
    "sim.feat_api": "API / integrations",
    "sim.host_none": "None",
    "sim.host_std": "Standard",
    "sim.host_prem": "Premium",
    "sim.host_yearly": "/yr",
    "sim.row_base": "Base —",
    "sim.row_extra": "Extra pages",
    "sim.row_features": "Features",
    "sim.row_host": "Hosting (yr)",
    "sim.row_domain": "Domain (yr)",

    "contact.label": "· 05 — Contact",
    "contact.title_a": "Let's talk about your ",
    "contact.title_em": "project",
    "contact.title_b": ".",
    "contact.intro":
      "Tell us about your need in a few lines. We get back within 24 hours with a first take.",
    "contact.f_name": "Name *",
    "contact.f_email": "Email *",
    "contact.f_phone": "Phone",
    "contact.f_message": "Your project *",
    "contact.cta": "Send message",
    "contact.sending": "Sending…",
    "contact.success": "Message sent. We'll get back within 24h.",
    "contact.error": "Send failed. Try again.",
    "contact.location": "France · Remote",
    "contact.box_t": "Client area",
    "contact.box_d":
      "Create an account to track your project, chat live and review your quotes in one place.",

    "footer.tagline":
      "Independent web development studio. Marketing sites, e-commerce and tailor-made apps. Hosting and maintenance included.",
    "footer.nav": "Navigation",
    "footer.contact": "Contact",
    "footer.rights": "All rights reserved.",
    "footer.france": "Designed and hosted in France.",

    "auth.login.label": "Sign in",
    "auth.login.title": "Welcome back.",
    "auth.login.cta": "Sign in",
    "auth.login.busy": "Signing in…",
    "auth.login.no_account": "No account yet?",
    "auth.login.create": "Create one",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.register.label": "Sign up",
    "auth.register.title": "Create your client account.",
    "auth.register.name": "Full name",
    "auth.register.password": "Password (6 chars min)",
    "auth.register.cta": "Create my account",
    "auth.register.busy": "Creating…",
    "auth.register.have_account": "Already have an account?",
    "auth.register.signin": "Sign in",
    "auth.short_password": "Password: 6 chars min.",
    "auth.success": "Signed in.",
    "auth.welcome": "Welcome.",

    "verify.title": "Verify your email",
    "verify.intro":
      "We just sent you a verification link. Click it to activate your account.",
    "verify.resend": "Resend email",
    "verify.resent": "Email resent.",
    "verify.success": "Email verified. Welcome.",
    "verify.failed": "Invalid or expired link.",
    "verify.continue": "Go to my dashboard",
    "verify.banner_unverified":
      "Your email isn't verified yet. Click here to resend the link.",

    "dash.section": "· Client area",
    "dash.tab_overview": "Overview",
    "dash.tab_projects": "Projects",
    "dash.tab_quotes": "Quotes",
    "dash.tab_chat": "Messages",
    "dash.connected_as": "Signed in as",
    "dash.greeting": "Hi",
    "dash.greeting_intro":
      "Here's an overview of your activity. Run a simulation, browse your quotes or send us a message.",
    "dash.cta_quote": "New quote",
    "dash.cta_chat": "Start a conversation",
    "dash.card_projects": "Active projects",
    "dash.card_quotes": "Saved quotes",
    "dash.card_messages": "Messages",
    "dash.recent_quotes": "Latest quotes",

    "projects.intro": "Track your active projects.",
    "projects.new": "New project",
    "projects.title": "Title",
    "projects.description": "Description",
    "projects.create": "Create",
    "projects.creating": "Creating…",
    "projects.empty_t": "No projects yet.",
    "projects.empty_d": "Click \"New project\" to start.",
    "projects.created": "Project created.",
    "projects.create_failed": "Could not create.",
    "projects.status_nouveau": "New",
    "projects.status_en_cours": "In progress",
    "projects.status_livre": "Delivered",
    "projects.status_annule": "Cancelled",

    "quotes.intro": "Your saved quote simulations.",
    "quotes.new": "New quote",
    "quotes.empty_t": "No quotes yet.",
    "quotes.empty_d": "Run a simulation to generate your first quote.",

    "chat.title": "Conversation",
    "chat.online": "Online",
    "chat.offline": "Reply within 24h",
    "chat.typical": "Replies within 2 to 24 hours",
    "chat.empty": "Start the conversation. Describe your need.",
    "chat.placeholder": "Your message…",
    "chat.send": "Send",
    "chat.aside_note":
      "Our team checks messages several times a day. For urgencies, prefix your message with \"URGENT\".",

    "demos.back": "Back to site",
    "demos.preview_label": "Demo",
    "demos.note":
      "This example is an interactive preview built by Versant Studio. We can adapt it to your brand.",
    "demos.cta_quote": "Estimate a similar project",

    "admin.title": "Creator area",
    "admin.online_users": "Visitors online",
    "admin.no_online": "No connected visitor right now.",
    "admin.conversations": "Conversations",
    "admin.no_conv": "No conversation yet.",
    "admin.contacts": "Contact requests",
    "admin.no_contacts": "No contact requests.",
    "admin.users": "Users",
    "admin.tab_overview": "Overview",
    "admin.tab_inbox": "Inbox",
    "admin.tab_users": "Users",
    "admin.tab_contacts": "Contacts",
    "admin.reply_placeholder": "Type your reply…",
    "admin.reply_send": "Send reply",
    "admin.stat_users": "Clients",
    "admin.stat_quotes": "Quotes",
    "admin.stat_projects": "Projects",
    "admin.stat_contacts": "Contacts",
    "admin.stat_unread": "Unread messages",
    "admin.select_conv": "Select a conversation to see the messages.",
  },
};
